import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-mini-contact-us',
  templateUrl: './mini-contact-us.component.html',
  styleUrls: ['./mini-contact-us.component.scss']
})
export class MiniContactUsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
